import React from 'react';
import logo from '../assets/logo2.png';
import image1 from '../assets/studio1.jpg';
import image2 from '../assets/studio2.jpg';
import mobileAboutImage from '../assets/about-mobile.jpg'; // Your mobile version screenshot
import { FaTruck, FaBoxOpen, FaCertificate } from 'react-icons/fa';

const AboutPage = () => {
  return (
    <div className="bg-[#f5f3ef] min-h-screen pt-10 text-[#2A2A2A] font-['Helvetica Neue','Helvetica','Arial',sans-serif]">
      
      {/* === MOBILE VIEW ONLY === */}
      <div className="block md:hidden">
        <img
          src={mobileAboutImage}
          alt="About MORY mobile"
          className="w-full h-full object-cover"
        />
      </div>

      {/* === DESKTOP VIEW ONLY === */}
      <div className="hidden md:grid max-w-6xl mx-auto grid-cols-2 px-6 py-16 gap-12 items-start">
        {/* LEFT TEXT COLUMN */}
        <div className="space-y-6">
          <img src={logo} alt="MORY Logo" className="h-14 mb-2" />
          <p className="text-[13px] tracking-widest uppercase text-[#8b8b8b] font-medium">
            Pearls for the Pearl
          </p>
          <h1 className="text-[30px] leading-10 tracking-[.08em] uppercase font-light">
            About Us
          </h1>
          <p className="text-[15px] leading-[28px] font-light">
            MORY® designs, manufactures and markets hand-finished and contemporary jewellery made from high quality materials at affordable prices.
          </p>
          <p className="text-[15px] leading-[28px] font-light">
            MORY is committed to making high-quality jewellery. Each unique design passes through the hands of highly skilled craftspeople, who expertly craft our contemporary, stylish and feminine jewellery in 21k gold.
          </p>
          <p className="text-[15px] leading-[28px] font-light">
            Founded in 2014 based in Erbil, Iraq with a different brand name, then changed to MORY.
          </p>
          <div className="flex items-start gap-4 mt-6">
            <FaTruck className="text-xl mt-1 text-[#666]" />
            <p className="text-[15px] leading-[26px] font-light">
              We have free delivery to all cities in Iraq. All orders will arrive 7 to 9 business days after ordering.
            </p>
          </div>
          <div className="flex items-start gap-4">
            <FaBoxOpen className="text-xl mt-1 text-[#666]" />
            <p className="text-[15px] leading-[26px] font-light">
              Our packaging services are the perfect finishing touch for your precious pieces.
            </p>
          </div>
          <div className="flex items-start gap-4">
            <FaCertificate className="text-xl mt-1 text-[#666]" />
            <p className="text-[15px] leading-[26px] font-light">
              At MORY, authenticity is our top priority. Each piece of jewelry comes with a certificate of authenticity, giving you confidence that your jewelry is certified and of the highest quality.
            </p>
          </div>
        </div>

        {/* RIGHT IMAGES COLUMN */}
        <div className="flex flex-col gap-6">
          <div className="h-[350px] rounded-md overflow-hidden shadow">
            <img
              src={image1}
              alt="Crafting Jewelry"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="h-[350px] rounded-md overflow-hidden shadow">
            <img
              src={image2}
              alt="Gemstones"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
